import { render, staticRenderFns } from "./CategoryGoodsPreview.vue?vue&type=template&id=3dcfdb02&"
import script from "./CategoryGoodsPreview.vue?vue&type=script&lang=js&"
export * from "./CategoryGoodsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports